(
    function (skyward, $)
    {
        skyward.grouptemplate = skyward.grouptemplate || {};

        var init = function (selector)
        {
            $(selector + " .GroupTemplateCheckbox").each(function ()
            {
                $(this).change(handleCheckChange);
            });
        };

        var handleCheckChange = function ()
        {
            if (this.checked)
            {
                $(this).prevAll(":input").prop('checked', true);
            }
            else
            {
                $(this).nextAll(":input").prop('checked', false);
            }
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);

